"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  flex: 1;\n  padding: 1.5rem;\n  min-width: 25rem;\n  box-shadow: var(--box-shadow-node);\n\n  font-size: var(--font-size-medium);\n  font-weight: bold;\n  color: var(--color-grey-dark-2);\n  text-align: center;\n\n  background-color: #fff;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: var(--font-size-medium);\n  color: var(--color-grey-dark-2);\n  font-weight: bold;\n  text-align: center;\n  min-width: 25rem;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: rgba(0, 0, 0, 0.1);\n\n  padding: 2.5rem;\n  padding-bottom: 3rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 2rem;\n  margin-right: 1rem;\n  color: var(--color-primary-light-2);\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  font-size: var(--font-size-medium);\n  color: var(--color-primary-light-1);\n  background-color: var(--color-grey-dark-1);\n\n  padding: 1rem 1.5rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  width: max-content;\n\n  max-width: ", ";\n  overflow: scroll;\n\n  box-shadow: 0px 10px 13px -7px rgba(0, 0, 0, 0.25),\n    5px 5px 15px 5px rgba(0, 0, 0, 0);\n\n  animation: show 0.2s;\n  @keyframes show {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var MAX_WIDTH = '40rem';
exports.StyledActionPreviewWrapperDiv = styled_components_1.default.div(_templateObject(), MAX_WIDTH);
exports.StyledActionPreviewTitleH2 = styled_components_1.default.h2(_templateObject2());
exports.StyledFontAwesomeIcon = styled_components_1.default(react_fontawesome_1.FontAwesomeIcon)(_templateObject3());
exports.StyledActionPreviewDiv = styled_components_1.default.div(_templateObject4());
exports.StyledEmptyMessageP = styled_components_1.default.p(_templateObject5());
exports.StyledActionUrlP = styled_components_1.default.p(_templateObject6());